import { create } from 'zustand'
import type { GcpAnalysisResult, GcpRecommendationsResult } from '@/services/gcpCosts'

export type GcpJobStatus = 'idle' | 'pending' | 'running' | 'completed' | 'failed'

interface GcpCostsState {
  windowPresetId: string
  metricsDays: number
  analysisJobId: number | null
  recommendJobId: number | null
  analysisStatus: GcpJobStatus
  recommendStatus: GcpJobStatus
  analysisResult: GcpAnalysisResult | null
  recommendationsResult: GcpRecommendationsResult | null
  analysisError: string | null
  recommendError: string | null
  lastRunAt: string | null

  setWindowPresetId: (id: string) => void
  setMetricsDays: (days: number) => void
  setAnalysisJobId: (id: number | null) => void
  setRecommendJobId: (id: number | null) => void
  setAnalysisStatus: (status: GcpJobStatus) => void
  setRecommendStatus: (status: GcpJobStatus) => void
  setAnalysisResult: (result: GcpAnalysisResult | null) => void
  setRecommendationsResult: (result: GcpRecommendationsResult | null) => void
  setAnalysisError: (error: string | null) => void
  setRecommendError: (error: string | null) => void
  setLastRunAt: (iso: string | null) => void
  resetForNewRun: () => void
}

export const useGcpCostsStore = create<GcpCostsState>((set) => ({
  windowPresetId: '90d',
  metricsDays: 30,
  analysisJobId: null,
  recommendJobId: null,
  analysisStatus: 'idle',
  recommendStatus: 'idle',
  analysisResult: null,
  recommendationsResult: null,
  analysisError: null,
  recommendError: null,
  lastRunAt: null,

  setWindowPresetId: (id) => set({ windowPresetId: id }),
  setMetricsDays: (days) => set({ metricsDays: days }),
  setAnalysisJobId: (id) => set({ analysisJobId: id }),
  setRecommendJobId: (id) => set({ recommendJobId: id }),
  setAnalysisStatus: (status) => set({ analysisStatus: status }),
  setRecommendStatus: (status) => set({ recommendStatus: status }),
  setAnalysisResult: (result) => set({ analysisResult: result }),
  setRecommendationsResult: (result) => set({ recommendationsResult: result }),
  setAnalysisError: (error) => set({ analysisError: error }),
  setRecommendError: (error) => set({ recommendError: error }),
  setLastRunAt: (iso) => set({ lastRunAt: iso }),
  resetForNewRun: () =>
    set({
      analysisResult: null,
      recommendationsResult: null,
      analysisError: null,
      recommendError: null,
      recommendJobId: null,
      recommendStatus: 'idle',
    }),
}))
